import envRoutes from './env-routes';

const serverEnv = import.meta.env.VITE_SERVER || 'production';

export default {
  ...envRoutes[serverEnv],
  serverEnv,
};
